const MODE = process.env.REACT_APP_ENV
const API_URL = process.env.REACT_APP_API
const WEBSITE_URL = process.env.REACT_APP_WEBSITE


export {MODE, API_URL, WEBSITE_URL}